/* ==========================================================================
   BJW Health theme - product page (vanilla JS)
   - Variant selection from the JSON in [data-variants-json] (no network calls)
   - Updates price, compare price, discount badge, availability, low-stock note,
     hidden variant id, add-to-cart state, ?variant= URL and gallery position
   - Gallery: thumbnails <-> swipe track sync, click-to-zoom <dialog>
   - Quantity stepper
   - Related products (Shopify recommendations) via [data-related-url]
   ========================================================================== */
(function () {
  'use strict';

  function initProduct(section) {
    var variants;
    try { variants = JSON.parse(section.querySelector('[data-variants-json]').textContent); }
    catch (e) { return; }

    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price-current]');
    var compareEl = section.querySelector('[data-price-compare]');
    var badgeEl = section.querySelector('[data-price-badge]');
    var priceWrap = section.querySelector('.product__price');
    var availEl = section.querySelector('[data-availability]');
    var addBtn = section.querySelector('[data-add-to-cart]');
    var threshold = parseInt(section.getAttribute('data-low-stock'), 10) || 0;
    var track = section.querySelector('[data-gallery-track]');
    var thumbs = section.querySelector('[data-gallery-thumbs]');

    /* ----- Variants ----- */
    function selectedOptions() {
      return Array.prototype.map.call(section.querySelectorAll('.option'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function findVariant() {
      if (variants.length === 1) return variants[0];
      var sel = selectedOptions();
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0] || null;
    }
    function render(v, initial) {
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-soldout-label');
        availEl.innerHTML = '<span class="dot dot--out"></span> Unavailable';
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = v.price;
      var onSale = !!v.compare;
      compareEl.hidden = !onSale;
      badgeEl.hidden = !onSale;
      if (onSale) { compareEl.textContent = v.compare; badgeEl.textContent = v.off_label; }
      priceWrap.classList.toggle('price--on-sale', onSale);

      var label = v.available ? addBtn.getAttribute('data-label') : addBtn.getAttribute('data-soldout-label');
      addBtn.disabled = !v.available;
      addBtn.textContent = label;
      // quick-add handler restores `data-label` after adding; keep it correct
      if (v.available) addBtn.setAttribute('data-label', addBtn.getAttribute('data-label'));

      var low = v.available && threshold > 0 && v.stock && v.stock <= threshold;
      availEl.innerHTML = v.available
        ? '<span class="dot dot--ok"></span> ' + (low ? 'Only ' + v.stock + ' left' : 'In stock')
        : '<span class="dot dot--out"></span> ' + addBtn.getAttribute('data-soldout-label');

      if (initial) return; // first paint: keep URL and gallery position as rendered by Liquid

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      if (v.media_id) showMedia(v.media_id);
    }

    section.querySelectorAll('.option').forEach(function (fs) {
      fs.addEventListener('change', function () {
        var checked = fs.querySelector('input:checked');
        var out = fs.querySelector('[data-option-selected]');
        if (checked && out) out.textContent = checked.value;
        render(findVariant());
      });
    });

    /* ----- Quantity ----- */
    var qty = section.querySelector('.qty__input');
    var minus = section.querySelector('[data-qty-minus]');
    var plus = section.querySelector('[data-qty-plus]');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    /* ----- Gallery ----- */
    function slideById(id) { return track && track.querySelector('[data-media-id="' + id + '"]'); }
    function setActiveThumb(id) {
      if (!thumbs) return;
      thumbs.querySelectorAll('.gallery__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-thumb-for') === String(id));
      });
    }
    function showMedia(id) {
      var s = slideById(id);
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' });
      setActiveThumb(id);
    }
    if (thumbs) {
      thumbs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-thumb-for]');
        if (b) showMedia(b.getAttribute('data-thumb-for'));
      });
    }
    if (track) {
      var t = null;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var slides = track.querySelectorAll('.gallery__slide');
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          if (slides[idx]) setActiveThumb(slides[idx].getAttribute('data-media-id'));
        }, 80);
      }, { passive: true });
    }

    /* ----- Zoom ----- */
    var dlg = section.querySelector('[data-zoom-dialog]');
    if (dlg && typeof dlg.showModal === 'function') {
      var zimg = dlg.querySelector('[data-zoom-img]');
      section.addEventListener('click', function (e) {
        var z = e.target.closest('[data-zoom-src]');
        if (z) { zimg.src = z.getAttribute('data-zoom-src'); dlg.showModal(); }
        else if (e.target.closest('[data-zoom-close]') || e.target === dlg) dlg.close();
      });
    }

    render(findVariant() || variants[0], true);
  }

  /* ----- Related products ----- */
  function initRelated(el) {
    var url = el.getAttribute('data-related-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('[data-related-url]');
        if (src && src.querySelector('.product-card')) {
          el.innerHTML = src.innerHTML;
          el.hidden = false;
        }
      })
      .catch(function () {});
  }

  function boot(scope) {
    scope.querySelectorAll('[data-product-section]').forEach(initProduct);
    scope.querySelectorAll('[data-related-url]').forEach(initRelated);
  }
  boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
